import React  from 'react';
import _ from 'lodash';

const ListaitemsLI = (props) => (
    <li className='card card-plain card fdv-hist-event card-lg'>

    <i className='fdv-hist-event-icon ion-checkmark-circled' style={{'color':props.primeroEsVerde?'#1DB89B':'#cccccc'}} />

    <div className='fdv-hist-event-head'>
      <h5 className='fdv-hist-event-title'>{_.capitalize(props.title)}</h5>
    </div>
    <ul className='list'>

      {
        props.rows.map((item,i)=>
        <li>

        <div className='fdv-hist-event-head'>
         <p style={{'margin-bottom':'0px'}} >
          <i
          className={`
          ${(item.indReqAutHito === 'S' ? 'ion-person-stalker' : 'ion-checkmark')}
          ${(item.indActRealizada === 'S' ? 'c-green' : 'c-gray-1')}`}
          style={{'margin-right': '10px'}}
        />
            <span className='mr-2'>{_.capitalize(item.desAutFichaVta)} </span></p>
          <p className='subInfo'>{item.nomAut} {item.fecUsuarioAut === null?'':'el'} {item.fecUsuarioAut}</p>
        </div>
      </li>
      )
      }
    </ul>
    </li>

  );

const Resumen = (props) =>(
<section className='fdv-section tab-pane active' id='resumen'>
    <header className='fdv-section-head'>
      <h5 className='fdv-section-title'>Resumen</h5>
    </header>
    {console.log('props.pedidosAutorizaciones ',props.pedidosAutorizaciones )}
    <ul>
      {
        props.pedidosAutorizaciones !== undefined && props.pedidosAutorizaciones.length>0 ?(
            props.pedidosAutorizaciones.map((row,i)=>

          <ListaitemsLI
            title = {row[0].desHitoFive}
            rows ={row}
            primeroEsVerde={_.size(row) === _.size(row.filter((x, i) => x.indActRealizada === 'S' ))}
          />
          )
        ):(null)
      }
    </ul>
  </section>
);
export default Resumen;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/ItemsDetalle/Resumen.js